export default "__VITE_ASSET__CbyRL1FO__"